module.exports = __webpack_public_path__ + "img/designOfQuityPic.2cd3d14f.png";